import React, { FC } from 'react'

import s from './WixMobileFooter.scss'

interface WixMobileFooterProps {}

export const WixMobileFooter: FC<WixMobileFooterProps> = ({ children }) => {
  return <footer className={s.footer}>{children}</footer>
}
